export default __webpack_public_path__ + "static/media/signup-circle-3.c5abee0b.svg";